module.exports = __webpack_public_path__ + "img/0.18fd881a.png";